import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Switch, Text } from "@pentabd/ui";

import { InputDateControllerRow } from "@components";
import { NOA_FROM } from "../..";

export const NOAIssue = () => {
  const { control, register, setValue } = useFormContext();

  const { t } = useTranslation();

  return (
    <>
      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.NOA.FORM.ISSUE_DATE"
        register={{ ...register(NOA_FROM.ISSUE_DATE) }}
        name={NOA_FROM.ISSUE_DATE}
      />

      <div className="d-flex flex-column gap-10 py-10">
        <div className="row">
          <div className="col-md-12 col-lg-3">
            <Text weight="semibold" color="title" size="sm" component="p">
              {t("PROCUREMENT_CREATE.NOA.FORM.ACCEPTED_BY_VENDOR.LABEL")}
            </Text>
          </div>
          <div className="col-md-12 col-lg-7">
            <Controller
              control={control}
              name={NOA_FROM.ACCEPTED_BY_VENDOR}
              render={({ field }) => {
                return (
                  <Switch
                    {...register(NOA_FROM.ACCEPTED_BY_VENDOR)}
                    id={NOA_FROM.ACCEPTED_BY_VENDOR}
                    name="groups"
                    size="sm"
                    value={field.value}
                    onChange={(e) =>
                      setValue(NOA_FROM.ACCEPTED_BY_VENDOR, e.target.checked)
                    }
                    controlling
                  />
                );
              }}
            />
          </div>
        </div>
      </div>

      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.NOA.FORM.ACCEPTANCE_DATE"
        register={{ ...register(NOA_FROM.ACCEPTANCE_DATE) }}
        name={NOA_FROM.ACCEPTANCE_DATE}
      />

      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.NOA.FORM.PROJECT_START_DATE"
        register={{ ...register(NOA_FROM.PROJECT_START_DATE) }}
        name={NOA_FROM.PROJECT_START_DATE}
      />

      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.NOA.FORM.PROJECT_END_DATE"
        register={{ ...register(NOA_FROM.PROJECT_END_DATE) }}
        name={NOA_FROM.PROJECT_END_DATE}
      />
    </>
  );
};
